import React from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import Footer from "../Footer";
import CampaignHeader from "./CampaignHeader";
import SendingAccountBox from "./SendingAccountBox";
import LeadSettingBox from "./LeadSettingBox";
import CrmBox from "./CrmBox";


const CampaignSettings = () => {
    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
            <div className="campaign-pages-wrap">
                <CampaignHeader page={'settings'}/>
                <div className="campaign-settings-wrap">
                    <div className="campaign-settings">
                        <SendingAccountBox/>
                        <LeadSettingBox/>
                        {/* <CrmBox/> */}
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
        </>);
}

export default CampaignSettings;